import React from "react";

import apple from "assets/graphics/icons/apple--black.svg";
import android from "assets/graphics/icons/android--black.svg";
import wall from "assets/graphics/pictures/wall.jpg";
import smartphone from "assets/graphics/pictures/smartphone.png";

import "features/new/portal/view.scss";

const PortalView = () => (
  <section className="main__portal" id="portal">
    <div className="portal__content">
      <div className="portal__container">
        <h2 className="portal__headline main__animation--fade-in">
          The Portal
        </h2>
        <p className="portal__description main__animation--fade-in">
          Members have access to the Parlor platform through our mobile app. The
          member portal is the gateway to the full, curated social calendar, as
          well as a way to connect with other members.
        </p>
      </div>
    </div>
    <div className="portal__container portal__fake">
      <img className="portal__image" src={wall} alt="wall" />
      <img
        className="portal__smartphone main__animation--fade-in portal__animation--slide-in"
        src={smartphone}
        alt="download parlor social club mobile app"
      />
      <p className="portal__information">Download Here</p>
      <div className="portal__stores">
        <a
          href="https://apps.apple.com/us/app/parlor-social-club/id1473428896"
          target="blank"
          onClick={() => window.dataLayer.push({ event: "iosVisited" })}
        >
          <img
            className="portal__store--apple"
            src={apple}
            alt="parlor social club app on ios"
          />
        </a>
        <a
          href="https://play.google.com/store/apps/details?id=social.parlor.app"
          target="blank"
          onClick={() => window.dataLayer.push({ event: "androidVisited" })}
        >
          <img
            className="portal__store--android"
            src={android}
            alt="parlor social club app on android"
          />
        </a>
      </div>
    </div>
  </section>
);

export default PortalView;
